import Vue from 'vue'

Vue.prototype.$assetStates = [
  'New',
  'Review',
  'Edit',
  'Preflight',
  'Approved'
]
